/**
 * Line icons for the issue table's optional columns, drawn as vector paths.
 *
 * Used in place of the header words when the ticked columns leave too little
 * room for them: an ellipsised "Comm…" names nothing, an icon still does, and
 * the key under the table spells each one out.
 */
import { LineCapStyle, type Color, type PDFPage } from "pdf-lib";
import type { ProtocolColumnId } from "@/domains/pm/utils/protocol";

/** Paths on a 24-unit grid, y pointing down, stroked and never filled. */
const ICON_PATHS: Record<ProtocolColumnId, string> = {
  // A ticked circle: where the issue stands.
  status: "M12 3a9 9 0 1 1 0 18a9 9 0 1 1 0-18z M8 12.5l2.8 2.8L16 9.5",
  // A person.
  assignees: "M12 12a4 4 0 1 0 0-8a4 4 0 1 0 0 8z M4.5 21a7.5 7.5 0 0 1 15 0",
  // A tag, as the disciplines are in the app.
  disciplines: "M3 3h8l10 10l-8 8L3 11z M7.5 7.5h.01",
  // A calendar for the start, a flag for the finish line.
  startDate: "M4 5h16v15H4z M4 10h16 M8 3v4 M16 3v4",
  dueDate: "M5 21V4 M5 4h12l-2.5 4l2.5 4H5",
  // A speech bubble.
  commentCount: "M4 5h16v11H10l-4 4v-4H4z",
};

const GRID = 24;
/** The stroke on the 24-unit grid; scaled with the path. */
const STROKE = 1.9;

/** Draws `column`'s icon `size` points square with its top-left at (x, top). */
export function drawColumnIcon(
  page: PDFPage,
  column: ProtocolColumnId,
  x: number,
  top: number,
  size: number,
  color: Color
): void {
  page.drawSvgPath(ICON_PATHS[column], {
    x,
    y: top,
    scale: size / GRID,
    borderColor: color,
    borderWidth: STROKE,
    borderLineCap: LineCapStyle.Round,
  });
}
